import i18n from 'i18n/config';
import { WarningAccountIcon } from 'styles/assets/icons';
import Box from 'UIKit/Box';

import styles from './accountRefreshTriggerStrip.module.scss';

const accountRefreshTriggerStripLabel = i18n.t(
  'headerFooter:accountRefreshTriggerStripMessage'
);

const AccountRefreshTriggerStrip = () => {
  return (
    <Box className={styles.container}>
      <Box className={styles.iconMessageContainer}>
        <WarningAccountIcon />
        <Box as="span" className={styles.message}>
          {accountRefreshTriggerStripLabel}
        </Box>
      </Box>
    </Box>
  );
};

export default AccountRefreshTriggerStrip;
